import Banner from '../../assets/website/orange-pattern.jpg';


const BannerImag = {
  backgroundImage: `url(${Banner})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  height: '100%',
  width: '100%',
};

const Subscribe = () => {
  return (
    <div 
      data-aos='zoom-in'
      className='mb-20 bg-gray-100 dark:bg-gray-800 text-white'
      style={BannerImag}
    >
      <div className='container backdrop-blur-sm py-10'>
        <div className='space-y-6 max-w-xl mx-auto'>
          <h1 className='text-2xl !text-center sm:text-left sm:text-4xl font-semibold'>
            Get Notified About New Products
          </h1>
          <input
            data-aos='fade-up'
            type='text'
            placeholder='Enter your email'
            className='w-full p-3'
          />
        </div>
        <div className="flex justify-center">
            <button className="text-center font-bold mt-10 cursor-pointer hover:text-primary bg-secondary hover:bg-white -translate-x-1/2 duration-300 text-white py-1 px-5 rounded-md">
              Subscribe
            </button>
          </div>
      </div>
    </div>
  )
}
export default Subscribe;